/**
 * 四舍五入
 * @param {Number} num
 * @param {Number} decimal
 * @param {'floor' || 'round' || 'ceil'} cmd
 */
export default function(num, decimal, cmd) {
  if (!decimal && decimal !== 0) {
    decimal = 2;
  }
  let func;
  if (typeof cmd === 'function') {
    func = cmd;
  } else {
    switch (cmd) {
      case 'floor':
        func = Math.floor;
        break;
      case 'round':
        func = Math.round;
        break;
      case 'ceil':
        func = Math.ceil;
        break;
      default:
        func = Math.round;
    }
  }
  const rate = 1 / `1e${-decimal}`;
  // toFixed保留尽可能多的位，避免四舍五入进位导致出错
  return (func((num * rate).toFixed(10)) / rate).toFixed(decimal);
}
